/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type DeleteMentorShiftMutationVariables = Types.Exact<{
  id: Types.Scalars["Int"];
}>;

export type DeleteMentorShiftMutation = {
  deleteMentorShift: Pick<Types.Success, "status">;
};

export const DeleteMentorShiftDocument = gql`
  mutation DeleteMentorShift($id: Int!) {
    deleteMentorShift(id: $id) {
      status
    }
  }
`;

/**
 * __useDeleteMentorShiftMutation__
 *
 * To run a mutation, you first call `useDeleteMentorShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMentorShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMentorShiftMutation, { data, loading, error }] = useDeleteMentorShiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMentorShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMentorShiftMutation,
    DeleteMentorShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteMentorShiftMutation,
    DeleteMentorShiftMutationVariables
  >(DeleteMentorShiftDocument, baseOptions);
}
export type DeleteMentorShiftMutationHookResult = ReturnType<
  typeof useDeleteMentorShiftMutation
>;
export type DeleteMentorShiftMutationResult =
  ApolloReactCommon.MutationResult<DeleteMentorShiftMutation>;
export type DeleteMentorShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteMentorShiftMutation,
    DeleteMentorShiftMutationVariables
  >;
